"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var history_1 = require("history");
exports.default = history_1.createBrowserHistory();
//# sourceMappingURL=History.js.map